<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-select placeholder="类型" v-model="filters.type">
          <el-option :value="-1" label="全部" />
          <el-option :value="0" label="充值" />
          <el-option :value="1" label="消费" />
        </el-select>
        <el-select v-model="filters.customerId"
                   filterable
                   remote
                   reserve-keyword
                   clearable
                   placeholder="请输入客户关键词"
                   :remote-method="getCustomers"
                   :loading="loading">
          <el-option v-for="item in customers"
                     :key="item.customerId"
                     :label="item.name"
                     :value="item.customerId">
          </el-option>
        </el-select>
        <el-form-item>
          <el-button type="primary" v-on:click="getESigns">查询</el-button>
        </el-form-item>
      </el-form>      
    </el-col>

    <!--列表-->
    <el-table :data="signDetails" highlight-current-row v-loading="listLoading"  @sort-change="sortchange" :height="bodyHeight-220">
      <!-- <el-table-column type="selection" width="55">
  </el-table-column> -->
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="type" label="类型" width="80" sortable="custom">
        <template slot-scope="scope">
          <i class="el-icon-circle-plus" v-if="scope.row.type===0" style="color:green"></i>
          <i class="el-icon-remove" v-else style="color:coral"></i>
          {{ formatType(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="客户编码" width="120" sortable="custom">
      </el-table-column>
      <el-table-column prop="name" label="客户名称" min-width="180" sortable="custom">
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" width="180" sortable="custom" :formatter="formatdatetime">
      </el-table-column>
      <el-table-column prop="count" label="次数" align="center" width="100" sortable="custom">
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>   

  </section>
</template>
<style>
  .el-input-group .el-select .el-input{
    width:90px;
  }
  i.Blue {
    color:#20A0FF
  }
  i.Success {
    color:#13CE66
  }
  i.Warning {
    color:#F7BA2A
  }
  /* .el-dialog__body {
    height: 600px;
    overflow-y:auto;
  } */
</style>

<script>
export default {
  name: 'eSignDetailView',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        customerId: this.$route.query.customerId || null,
        type: -1
      },
      listLoading: false,
      loading: false,
      sortname: 'createDate',
      sorttype: 'desc',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      signDetails: [
      ],
      customers: [
      ]
    }
  },
  methods: {
    formatdatetime: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    // 显示转换
    formatType: function(v) {
      if (v === 0) {
        return '充值'
      } else if (v === 1) {
        return '消费'
      } else {
        return '未知'
      }
    },
    getCustomers: function (q) {
      if (q !== '') {
        let para = {
          keywords: q,
          pageno: 1,
          pagesize: 100,
          sortname: 'Name',
          sorttype: 'asc'
        }
        this.$ajax({
          url: 'api/Customer/GetCustomers',
          method: 'get',
          data: para,
          loadingName: 'loading',
          success: (d, r) => {
            this.customers = d
            this.loading = false
          }
        })
      }
    },
    // 明列列表
    getESigns: function() {
      let para = {
        customerId: this.filters.customerId,
        type: this.filters.type,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }

      this.$ajax({
        url: 'api/Customer/GetESignDetails',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.signDetails = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    pageChange: function(val) {
      this.pageno = val
      this.getESigns()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getESigns()
    }
  },
  mounted() {
    this.getESigns()
  }
}
</script>
